const NOT_FOUND = -1;
const ZERO = 0;
const ONE = 1;

const MILLISECONDS_IN_SECOND = 1000;
const SECONDS_IN_MINUTE = 60;
const MINUTES_IN_HOUR = 60;
const HOURS_IN_DAY = 24;
const MINUTES_IN_DAY = MINUTES_IN_HOUR * HOURS_IN_DAY;
const DAYS_IN_WEEK = 7;
const DAYS_IN_YEAR = 365;

const THIRTY_DAYS_IN_SECONDS = 2592000;
const TWO_DAYS_IN_SECONDS = 172800;

const THREE_DAYS_IN_SECONDS = 259200;

const FIRST_QUARTER_FIRST_MONTH = 0;
const FIRST_QUARTER_LAST_MONTH = 2;
const SECOND_QUARTER_FIRST_MONTH = 3;
const SECOND_QUARTER_LAST_MONTH = 5;
const THIRD_QUARTER_FIRST_MONTH = 6;
const THIRD_QUARTER_LAST_MONTH = 8;
const FOURTH_QUARTER_FIRST_MONTH = 9;
const FOURTH_QUARTER_LAST_MONTH = 11;

const THOUSAND = 1000;

const GENERATIONS = {
  BRC: 2,
  REPLIBIT: 4
};

const INDEXOF_FALSE = -1;

const THRESHOLD_SETTINGS_INPUT_DEBOUNCE_MS = 250,
    FILTER_INPUT_DEBOUNCE_MS = 500,
    DEVICE_AND_JOB_THRESHOLD_SLIDER_VALUES = [120, 240, 480, 720, 1440, 2160, 2880, 4320, 10080, 20160, 43800, 131400, 262800, 525600],
    DEVICE_AND_JOB_THRESHOLD_SLIDER_BOUNDARY_VALUES = [4320, 43800, 525600],
    DEFAULT_SERVER_THRESHOLD_VALUE_MINUTES = 2160,
    DEFAULT_WORKSTATION_THRESHOLD_VALUE_MINUTES = 4320,
    LOCAL_CACHE_THRESHOLD_SLIDER_VALUES = [MINUTES_IN_DAY, 2 * MINUTES_IN_DAY, 3 * MINUTES_IN_DAY,
      7 * MINUTES_IN_DAY, 14 * MINUTES_IN_DAY],
    LOCAL_CACHE_THRESHOLD_SLIDER_BOUNDARY_VALUES = [MINUTES_IN_DAY],
    DEFAULT_LOCAL_CACHE_THRESHOLD_VALUE_MINUTES = 3 * MINUTES_IN_DAY
;

const LOGIN_FLOW_PAGES_ERROR_SHAKE_COUNT = 2,
    LOGIN_FLOW_PAGES_ERROR_SHAKE_PERIOD = 13,
    LOGIN_FLOW_PAGES_ERROR_SHAKE_DURATION = 250;

const CLASS_NAME_INVISIBLE = 'invisible';

const TIME_INTERVALS = [_1_hour, _2_hours, _4_hours, _8_hours, _12_hours, _24_hours, _36_hours, _48_hours, _3_days, _7_days];
const TIME_INTERVALS_IN_MINUTES = [60, 120, 240, 480, 720, 1440, 2160, 2880, 4320, 10080]

export {
  NOT_FOUND, ZERO, ONE, TWO_DAYS_IN_SECONDS, THIRTY_DAYS_IN_SECONDS, THOUSAND, GENERATIONS, INDEXOF_FALSE, FILTER_INPUT_DEBOUNCE_MS,
  THRESHOLD_SETTINGS_INPUT_DEBOUNCE_MS, DEVICE_AND_JOB_THRESHOLD_SLIDER_VALUES, DEVICE_AND_JOB_THRESHOLD_SLIDER_BOUNDARY_VALUES,
  DEFAULT_SERVER_THRESHOLD_VALUE_MINUTES, DEFAULT_WORKSTATION_THRESHOLD_VALUE_MINUTES,
  LOCAL_CACHE_THRESHOLD_SLIDER_VALUES, LOCAL_CACHE_THRESHOLD_SLIDER_BOUNDARY_VALUES, DEFAULT_LOCAL_CACHE_THRESHOLD_VALUE_MINUTES,
  LOGIN_FLOW_PAGES_ERROR_SHAKE_COUNT,
  LOGIN_FLOW_PAGES_ERROR_SHAKE_PERIOD, LOGIN_FLOW_PAGES_ERROR_SHAKE_DURATION,
  MILLISECONDS_IN_SECOND, SECONDS_IN_MINUTE, MINUTES_IN_DAY, THREE_DAYS_IN_SECONDS, CLASS_NAME_INVISIBLE, MINUTES_IN_HOUR,
  HOURS_IN_DAY, DAYS_IN_WEEK, DAYS_IN_YEAR,
  FIRST_QUARTER_FIRST_MONTH, FIRST_QUARTER_LAST_MONTH, SECOND_QUARTER_FIRST_MONTH, SECOND_QUARTER_LAST_MONTH,
  THIRD_QUARTER_FIRST_MONTH, THIRD_QUARTER_LAST_MONTH, FOURTH_QUARTER_FIRST_MONTH, FOURTH_QUARTER_LAST_MONTH,
  TIME_INTERVALS, TIME_INTERVALS_IN_MINUTES
};
